<div id="managePopUp">
  <div class="modal-header">
    <div class="modal-title">{{ individually ? authoringContentData?.changeNumber : authoringContentData?.changeNumbers}}</div>
    <button type="button" class="close" aria-label="Close" (click)="closePopupTagging()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="individually; else allLine">
    <div class="modal-body" *ngFor="let line of selectedLines">
      <div class="modal-subtitle">
        <span id="old-number">{{line?.msisdn}}</span>
      </div>
      <span id="process-error" style="display: none;"></span>

      <app-change-number-form [singleLineFlow]="individually" [msisdn]="line?.msisdn"></app-change-number-form>
    </div>
  </div>
  <ng-template #allLine>
    <div class="modal-body" id="multiLineChangeNumberPopup">
      <div class="modal-subtitle">
        <span id="old-number">{{selectedLines.length}} {{authoringContentData?.linesSelected}}</span>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="radio radio-primary">
            <input type="radio" id="assignAllRadioBtn" name="changeNumberSettings" value="Assign all" [(ngModel)]="checkedRadioButton"
              (click)="getModalValue($event)">
            <label for="assignAllRadioBtn" class="settingsOptions">
              {{authoringContentData?.assignSameSetting}}
            </label>
          </div>
          <div *ngIf="allLineOpenModal">
            <app-change-number-form [singleLineFlow]="individually" [singleSetting]="allLineOpenModal" [assignAll]="checkedRadioButton"
              [totalSelectedLines]="selectedLines.length"></app-change-number-form>
          </div>
          <div class="radio radio-primary">
            <input type="radio" id="assignIndividualRadioBtn" name="changeNumberSettings" value="Assign individual"
              [(ngModel)]="checkedRadioButton" (click)="getModalValue($event)">
            <label for="assignIndividualRadioBtn" class="settingsOptions">
              {{authoringContentData?.assignIndividualSetting}}</label>
          </div>
          <hr class="divider">
          <div *ngIf="!allLineOpenModal">
            <mat-accordion class="example-headers-align" *ngFor="let sline of selectedLines; let i=index;">
              <mat-expansion-panel [expanded]="sline.expendFlagValue" (closed)="expansionPanelClosed(sline)"
                (opened)="expansionPanelOpened(sline, i)">
                <mat-expansion-panel-header (click)="setStep(i)" class="specific-class">
                  <mat-panel-title class="accordion-txt">
                    <span class="succes_validator" *ngIf="sline?.succesValidator"></span>
                    <span class="suspend_error_complete" *ngIf="sline?.errorValidator"></span> {{sline?.msisdn}}                    
                    <div class="flex-fill text-left m-l-50" *ngIf="(sline?.succesValidator || sline?.errorValidator) && sline?.msgShowOnPanel">

                      <span class="small text-normal block font-tele-hal text-bold">{{manageLineService.changeNumberFlowResponseBody[i]?.npa}}-{{manageLineService.changeNumberFlowResponseBody[i]?.nxx}}</span>
                      <span class="xsmall text-normal block font-tele-hal text-gray ">{{authoringContentData?.requesting}}</span>
                    </div>

                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-change-number-form [singleLineFlow]="individually" [assignAll]="checkedRadioButton"
                  [removeLineIndex]="i" [singleSetting]="allLineOpenModal" [totalSelectedLines]="selectedLines.length"
                  [msisdn]="sline?.msisdn"></app-change-number-form>
                <div class="row align-items-center h-100 mt-4">
                  <div class="col-12 col-md-6 mb-2 ">
                    <button type="button" class="col-12 primary_btn pull-left" (click)="nextStep(sline)" [disabled]="!sline?.succesValidator">{{authoringContentData?.btnNextTxt}}
                    </button>
                  </div>
                  <div class="col-12 col-md-6 mb-2">
                    <a href="javascript:void(0)" (click)="removeNumber(i)" class="small-pink">{{authoringContentData?.removeNumberTxt}}
                    </a>
                  </div>

                </div>
              </mat-expansion-panel>
              <hr class="suspend-horizontalline" id="tmo-suspendMulti-horizontalLine_1">
            </mat-accordion>

          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="pb-5">
    <div class="modal-footer pb-0 pt-0">

      <div class="row">
        <div class="col-1 mt-3" [ngClass]="{'checkBoxDisabled': checkBoxDisabled}">
          <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="checkBoxDisabled"></mat-checkbox>
        </div>
        <div class="col-10 col-sm-11 col-md-6 acceptanceText mt-3">
          {{authoringContentData?.acceptanceText}}
        </div>
        <div class="col-12 col-md-5 mt-3">
          <button type="button" class="col-12 primary_btn float-right" (click)="submitChangeNumberRequest()" [disabled]="!selectsubmitCheckBox || isSubmitReadOnly">{{authoringContentData?.SubmitChangeBtn}}</button>
        </div>
      </div>


    </div>
    <div class="col-12" *ngIf="!checkBoxDisabled">
      <div class="mt-4">
        <div class="single-change-content">
          <p class="head">{{authoringContentData?.requestNumberCgangeTxt}}</p>
          <p class="content">{{authoringContentData?.requestNumberCgangeContentTxt}}</p>
          <p class="head">{{authoringContentData?.advisementsTxt}}</p>
          <p class="content" *ngIf="!chargeAdvisementFlag">{{authoringContentData?.advisementsConTxt}}</p>
          <p class="content" *ngIf="chargeAdvisementFlag">
            {{ authoringContentData?.advisementsConTxt }}
            <br>
            {{ authoringContentData?.advisementsCustEmpReqTxt }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>